export const WPP_VERIFY = 'WPP_VERIFY';
export const WPP_VERIFY_SUCCESSFUL = 'WPP_VERIFY_SUCCESSFUL';
export const WPP = 'WPP';
export const WPP_SUCCESSFUL = 'WPP_SUCCESSFUL';
